<template style="touch-action: none;">
  <v-container class="pa-0" fluid>
    <v-row class="text-center">
      <v-alert
        v-show="alertShow"
        style="position: absolute;left: 2rem;bottom: 2rem; z-index: 99;"
        class="text-title text-md-h6"
        dense
        v-bind:type="alertType"
      >
        {{ alert }}
      </v-alert>
      <v-toolbar class="rounded-lg" style="position: absolute;z-index: 10;right:20rem; top:1rem;">
        <GmapAutocomplete
          style="width:500px"
          ref="searchRef"
          :options="{fields: ['geometry']}"
          @place_changed='setPlace'
        />
        <v-btn @click='addMarker' icon>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-toolbar>
      <br>
      <GmapMap
        ref="mapRef"
        :center='center'
        :zoom='zoom'
        :options="mapOptions"
        style='width:100%;  height: 95vh;'
        @click="clickmap"
      >
      <template v-for="(m, index) in item_markers">
        <GmapMarker
          :key="'A'+ index"
          v-if="m.text != '未在打卡範圍內'"
          :position="m.position"
          :clickable="true"
          :draggable="false"
          @click="center=m.position"
          icon="http://maps.google.com/mapfiles/ms/icons/orange-dot.png"
          />
        <GmapCircle
          v-if="m.text != '未在打卡範圍內'"
          :key="'B'+ index"
          :center="m.position"
          :radius="m.position.range"
          :visible="true"
          :options="{fillColor:'green',fillOpacity:0.2}"
        ></GmapCircle>
        <gmap-info-window 
            v-if="m.text != '未在打卡範圍內'"
            :key="'X'+ index"
              :opened="true" 
              :position="m.position"
              :options="infoOptions"
          >
            {{ m.text }}
        </gmap-info-window>
      </template>
        
        <GmapMarker
          :key="'C'+ index"
          v-for="(m, index) in markers"
          :position="m.position"
          :clickable="true"
          :draggable="true"
          @drag="dragMarker"
          @click="center=m.position"
          
        />
        <GmapCircle
          v-for="(pin, index) in markers"
          :key="'D'+ index"
          :center="pin.position"
          :radius="slider"
          :visible="true"
          :options="{fillColor:'red',fillOpacity:0.4}"
        ></GmapCircle>
        <gmap-info-window 
              @closeclick="window_open=false" 
              :opened="window_open" 
              :position="infoposition"
              :options="infoOptions"
          >
             {{ markerName }}
          </gmap-info-window>
      </GmapMap>
      <v-dialog
        v-model="dialog"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">
            提醒
          </v-card-title>
  
          <v-card-text>
            確定要刪除此打卡位置嗎?
            (刪除後將無法復原)
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
  
            <v-btn
              color="green darken-1"
              text
              @click="dialog=false"
            >
              取消
            </v-btn>
  
            <v-btn
              color="green darken-1"
              text
              @click="api_delMarker"
            >
              確定
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-navigation-drawer
        absolute
        permanent
        right
        :opened="true" 
      >
        <template v-slot:prepend>
          <v-list-item two-line>
            <v-list-item-avatar>
              <img src="../assets/Qlogo.png">
            </v-list-item-avatar>
  
            <v-list-item-content>
              <v-list-item-title>群組名稱</v-list-item-title>
              <v-list-item-subtitle>{{ groupName }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-divider></v-divider>
        <v-list>
          <v-subheader>群組打卡位置</v-subheader>
          <v-list-item-group
            color="primary"
          >
            <v-list-item
              v-for="(mk, index) in item_markers"
              :key="'F'+ index"
              @click="goTo(mk.position)"
            >
              <v-list-item-icon>
                <v-icon v-text="mk.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="mk.text"></v-list-item-title>
                
              </v-list-item-content>
              <v-list-item-content>
                
                <v-btn
                color="white"
                depressed
                @click="chk_del(mk)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              </v-list-item-content>
              
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <v-divider></v-divider>
  
        <v-list dense v-show="isPoint">
          <v-subheader>新增打卡位置</v-subheader>
          <v-list-item
            v-for="item in items"
            :key="item.title"
          >
          <v-list-item-icon>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-icon>
  
            <v-list-item-content>
              <v-list-item-title>{{ item.content }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-text-field ref="_markerName" :rules="[chk_markerName]" v-model="markerName" label="地點名稱"></v-text-field>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>範圍</v-list-item-title>
              <v-slider
                v-model="slider"
                class="align-center"
                :max="max"
                :min="min"
                hide-details
              >
                <template v-slot:append>
                  <v-text-field
                    v-model="slider"
                    class="mt-0 pt-0"
                    hide-details
                    single-line
                    type="number"
                    style="width: 60px"
                  ></v-text-field>
                </template>
              </v-slider>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-btn
                color="gray"
                depressed
                style="width: 100%;"
                @click='goTo(markers[0].position)'
              >
                返回標點當前位置
              </v-btn>
            
          </v-list-item>
          <v-list-item>
            <v-btn
                color="primary"
                depressed
                style="width: 100%;"
                @click='api_addMarker'
              >
                <v-icon>mdi-plus-circle</v-icon>
                新增打卡點
              </v-btn>
            
          </v-list-item>
          <v-list-item-subtitle class="red--text">{{ errorMessage }}</v-list-item-subtitle>
        </v-list>
      </v-navigation-drawer>
    </v-row>
  </v-container>
</template>

<script>
  Array.prototype.remove = function() {
      var what, a = arguments, L = a.length, ax;
      while (L && this.length) {
          what = a[--L];
          while ((ax = this.indexOf(what)) !== -1) {
              this.splice(ax, 1);
          }
      }
      return this;
  };
  import axios from 'axios';
  import * as VueGoogleMaps from 'vue2-google-maps';
  export default {
    name: 'App',
    props: ['baseURL','baseLINE','baseAPI','baseADMIN','tax'],
    computed: {
      google: VueGoogleMaps.gmapApi,
    },
    data(){
      return{
        center: { lat: 45.508, lng: -73.587 },
        infoposition:{ lat: 45.508, lng: -73.587 },
        zoom:12,
        min: 0,
        max: 5000,
        slider: 40,
        markerName:"",
        items: [],
        item_markers: [
          { text: 'Real-Time', icon: 'mdi-flag',position:{lat:0,lng:0,range:0}},
          { text: 'Audience', icon: 'mdi-flag',position:{lat:0,lng:0,range:0}},
          { text: 'Conversions', icon: 'mdi-flag',position:{lat:0,lng:0,range:0}},
        ],
        item_spec_markers:[],
        currentPlace:null,
        markers: [],
        places: [],
        alertShow:true,
        alertType:"info",
        alert:"點擊任何一點開始新增打卡位置",
        infowindow:null,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },  
        mapOptions: {
          gestureHandling: "greedy"
        },  
        window_open:false,
        isPoint:false,
        str_groupid:"",
        groupName:"",
        errorMessage:"",
        pre_del:null,
        dialog:false
      }
    },
    
    
    mounted() {
      this.$store.commit('SET_LAYOUT', "app-layout")
      let query = this.$route.query;
      this.str_groupid = query['Groupid'];
      this.api_getGroupInfo();
      this.init();
      this.geolocate();
    },
    methods: {
      chk_markerName(value){
        console.log("被檢測",value);
        if(value ==""){
          return "請輸入打卡點名稱"
        }
        this.alert = "記得按下新增打卡點保存位置哦!"
        this.alertType="info";
        return true;
      },
      init(){
        
        this.$refs.mapRef.$mapPromise.then((map) => {
          console.log(this.google,map)
          let service = new this.google.maps.places.PlacesService(map);
          console.log(service)
          service.getDetails({
            placeId: '...',
            fields: ['opening_hours','utc_offset_minutes'],
            }, function (place, status) {
              if (status !== 'OK') return; // something went wrong
              const isOpenAtTime = place.opening_hours.isOpen(new Date('December 17, 2020 03:24:00'));
              if (isOpenAtTime) {
                  // We know it's open.
              }
  
              const isOpenNow = place.opening_hours.isOpen();
              if (isOpenNow) {
                  // We know it's open.
              }
          });
        })
      },
      setPlace(place) {
        this.currentPlace = place;
        this.addMarker();
      },
      goTo(pos){
        this.center = {lat:0,lng:0}
        setTimeout(() => {
          this.center = pos;
          this.zoom = 14;
        }, 100);
        
      },
      addMarker() {
        console.log(this.currentPlace);
        if (this.currentPlace!=null) {
          const marker = {
            lat: this.currentPlace.geometry.location.lat(),
            lng: this.currentPlace.geometry.location.lng(),
          };
          this.isPoint = true;
          this.window_open = true;
          this.places.push(this.currentPlace);
          this.markerName = "";
          this.markers = [];
          this.markers.push({ position: marker });
          this.items = [];
          this.items.push({title: '經度', content: marker.lat})
          this.items.push({title: '緯度', content: marker.lng})
          this.infowindow = "至右側選單新增打卡位置";
          this.alert = "至右側選單新增此打卡位置"
          this.alertType="info";
          this.infoposition = marker;
          this.center = marker;
          this.zoom = 14;
          this.currentPlace = null;
        }else{
          let lat = this.places[this.places.length-1].geometry.location.lat();
          let lng = this.places[this.places.length-1].geometry.location.lng();
          const marker = {
            lat: lat,
            lng: lng,
          };
          this.goTo(marker);
        }
      },
      clickmap:function(e){
        this.isPoint = true;
        this.markerName = "";
        this.window_open = true;
        const marker = {
            lat: e.latLng.lat(),
            lng: e.latLng.lng(),
          };
        this.markers = [];
        this.markers.push({ position: marker });
        this.items = [];
        this.items.push({title: '經度', content: marker.lat})
        this.items.push({title: '緯度', content: marker.lng})
        this.infowindow = "至右側選單新增打卡位置";
        this.alert = "至右側選單新增此打卡位置"
        this.alertType="info";
        this.infoposition = marker;
        //this.center = marker;
      },
      dragMarker:function(e){
        const marker = {
            lat: e.latLng.lat(),
            lng: e.latLng.lng(),
        };
        this.markers[0] = { position: marker };
        this.items[0].content = marker.lat;
        this.items[1].content = marker.lng;
        this.infoposition = marker;
      },
      geolocate: function() {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
        });
      },
      api_getGroupInfo(){
        console.log("群組編號",this.str_groupid);
        if(this.str_groupid == null)return;
        axios
        .get(this.baseURL+'/api/Punch/PunchinLocGet?LinegroupId='+this.str_groupid)
        .then((response)=>{
          console.log(response);
          let data = JSON.parse(response.data);
          this.groupName = data[0]["群組名稱"]
          this.item_markers = [];
          console.log("或得到",data)
          if(data[0]["fLatitude"] == null){
            return
          }
          for(let group in data){
            let lat = parseFloat(data[group]["fLatitude"])
            let lng = parseFloat(data[group]["fLongitude"])
            let range = parseFloat(data[group]["fRadius_Distance"])/3.28
            let _item ={ text: data[group]["fLocation_name"], icon: 'mdi-flag',position:{lat:lat,lng:lng,range:range}}
            //console.log("群組",_item);
            this.item_markers.push(_item);
            
            
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
          this.alert = "獲得資料失敗，請聯絡技術開發人員"
          this.alertType = "error";
        });
      },
      api_addMarker(){
        let lng = this.markers[0].position.lng;
        let lat = this.markers[0].position.lat;
        let range = this.slider;
        console.log(lng,lat,range,this.markerName);
        
        if(!this.$refs._markerName.validate()){
          this.errorMessage = "請輸入打卡點名稱";
        }else{
          this.errorMessage ="";
          axios
          .get(this.baseURL+'/api/Punch/GroupLocSet?str_GroupId='+ this.str_groupid +'&dou_Longitude='+ lng +'&dou_Latitude='+ lat +'&str_Location_name='+this.markerName+'&dou_Radius_Distance='+range)
          .then((response)=>{
            if(response.data == true){
              this.isPoint = false;
              this.alert = "儲存成功，開始新增下一個標點吧!"
              this.alertType = "success";
              this.markers.remove(this.markers[0]);
              let _item ={ text: this.markerName, icon: 'mdi-flag',position:{lat:lat,lng:lng,range:range}}
              this.item_markers.push(_item);
            }else{
              this.alert = "儲存失敗，請聯絡技術開發人員"
              this.alertType = "error";
            }
          })
          .catch(function (error) { // 请求失败处理
            console.log(error);
            this.alert = "儲存失敗，請聯絡技術開發人員"
            this.alertType = "error";
          });
        }
        
      },
      chk_del(item){
        this.dialog = true;
        this.pre_del = item;
      },
      api_delMarker(){
        let item = this.pre_del;
        this.dialog = false;
        axios
        .get(this.baseURL+'/api/Punch/Dele_Punch_in?str_GroupId='+ this.str_groupid +'&str_Location_name='+item.text)
        .then((response)=>{
          if(response.data == true){
            this.alert = "刪除成功，可以開始新增新的標點"
            this.alertType = "success";
            this.item_markers.remove(item);
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
          this.alert = "刪除失敗，請聯絡技術開發人員"
          this.alertType = "error";
        });
      },
    },
  }
  </script>
